import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import { createPinia } from 'pinia'
import BrokerageOverline from './components/BrokerageOverline.vue'

import { applyCachedTheme } from './utils/theme'

loadFonts()
applyCachedTheme()

createApp(App)
  .use(createPinia())
  .use(router)
  .use(vuetify)
  .component('BrokerageOverline', BrokerageOverline)
  .mount('#app')
